import { driversActions } from '../reducer';

type Operation = () => void;

export const resetAddingDriverFuelAssignmentStatus: Operation = () => driversActions.setAddingDriverFuelAssignmentStatus();
